import { WebPBackgroundImage } from '@pcln/content-tile'
import { Box, Flex, Link, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import { APP_DOWNLOAD_CONTENT } from '../constants'
import AppleStore from './graphics/AppleStoreSvg'
import PlayStore from './graphics/PlayStoreSvg'

const StyledLink = styled(Link)`
  margin-right: 8px;
`

const WrapperFlex = styled(Flex)`
  margin: 0 auto;
  max-width: 1280px;
`

const FlexDesktopOnly = styled(Flex)`
  display: none;
  ${(props) => props.theme.mediaQueries.lg} {
    display: flex;
    min-height: ${(props) => props.imageMinHeight};
    flex: 1;
  }
`

const StyledWebPImage = styled(WebPBackgroundImage)`
  visibility: hidden;
  background-position: right;
  ${(props) => props.theme.mediaQueries.lg} {
    visibility: visible;
    background-color: transparent;
    background-size: ${(props) => props.imageSize};
    flex: 1;
  }
`
const APP_DOWNLOAD_BUTTONS = (gaTracking, linkUrlOverride) => {
  return (
    <Box mb={5}>
      {APP_DOWNLOAD_CONTENT.buttons.map((button) => {
        const { gaLabel } = button
        return (
          <StyledLink
            href={linkUrlOverride || button.linkUrl}
            target='_blank'
            rel='noopener'
            key={gaLabel}
            onClick={() => {
              gaTracking(gaLabel)
            }}
            aria-label={`Open in ${gaLabel} app store`}
          >
            {gaLabel === 'Android' ? <PlayStore /> : <AppleStore />}
          </StyledLink>
        )
      })}
    </Box>
  )
}

const AppDownload = ({
  content,
  gaTracking = () => {},
  headingFontSize = 5,
  headingLineHeight = '',
  headlineColor = '',
  taglineTextStyle = '',
  bodyLineHeight = '',
  bodyFontSize = 3,
  bodyColor = 'text.light',
  tagLineTextColor = 'text.light',
  imageMinHeight = '',
  linkUrlOverride,
  ctaArea = APP_DOWNLOAD_BUTTONS(gaTracking, linkUrlOverride),
}) => {
  const { contentText, headingText, image, imageSize, imageWebP, smallHeadingText } =
    content || APP_DOWNLOAD_CONTENT

  return (
    <Box width={1} p={1} color='background.light'>
      <WrapperFlex flexWrap='wrap'>
        <Box px={1} mt={5} width={[1, 1, 1, 11 / 20]} textAlign={['center', 'center', 'center', 'left']}>
          <Box mb={3}>
            <Text
              fontWeight='bold'
              caps
              fontSize={0}
              mb={3}
              color={tagLineTextColor}
              textStyle={taglineTextStyle}
            >
              {smallHeadingText}
            </Text>
            <Text
              mb={3}
              fontWeight='bold'
              fontSize={headingFontSize}
              lineHeight={headingLineHeight}
              color={headlineColor}
            >
              {headingText}
            </Text>
            <Text fontSize={bodyFontSize} color={bodyColor} mb={2} lineHeight={bodyLineHeight}>
              {contentText}
            </Text>
          </Box>
          {ctaArea}
        </Box>
        <FlexDesktopOnly
          flexDirection='column'
          flexWrap='wrap'
          imageMinHeight={imageMinHeight}
          width={[1, null, null, 9 / 20]}
          px={1}
          my={-1}
        >
          <StyledWebPImage image={image} imageWebP={imageWebP} imageSize={imageSize} height='100%' />
        </FlexDesktopOnly>
      </WrapperFlex>
    </Box>
  )
}

export { AppDownload }
export default AppDownload
